export const COURSE_PATHS = {
  linux: {
    title: 'Linux foundations',
    description: 'Build confidence with the shell, files, permissions, and everyday Linux workflows.',
  },
  networking: {
    title: 'Networking practice',
    description: 'Practice DNS, routing, reachability, and HTTP troubleshooting.',
  },
  kubernetes: {
    title: 'Kubernetes operations',
    description: 'Operate and troubleshoot Kubernetes workloads with kubectl.',
  },
};

export function getCoursePath(course) {
  const configuredPath = String(course?.path || course?.category || course?.track || '').toLowerCase();

  if (Object.hasOwn(COURSE_PATHS, configuredPath)) {
    return configuredPath;
  }

  const searchableText = `${course?.id || ''} ${course?.title || ''} ${course?.description || ''}`.toLowerCase();
  if (searchableText.includes('kubernetes') || searchableText.includes('kubectl')) return 'kubernetes';
  if (searchableText.includes('network') || searchableText.includes('dns') || searchableText.includes('http')) return 'networking';
  return 'linux';
}
